var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apollo-query',{attrs:{"query":_vm.GET_PAYMENT_METHOD,"variables":{ id: _vm.id }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.result.data;
var isLoading = ref.isLoading;
return [(isLoading)?_c('s-loader'):(data && data.paymentMethod)?_c('div',[_c('PaymentMethodForm',{attrs:{"data":data.paymentMethod,"query":_vm.UPDATE_PAYMENT_METHOD},on:{"mutation-done":_vm.paymentMethodUpdated}})],1):_c('something-went-wrong')]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }